import NapsaReportComponent from 'components/Report/NapsaReport';
import PermissionGuard from 'components/Global/PermissionGuard'; // update the path if necessary

const NapsaReport = () => {
	return (
		<PermissionGuard permission="Allow_Payroll_Reports">
			<NapsaReportComponent />
		</PermissionGuard>
	);
};

export default NapsaReport;
